import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FullTable, SearchHistory, TabSwitcher } from 'components';
import { historyActions } from 'store';
import { historyBody, historyHead, historyNotYet } from '../../../history/constants';
import {
    STAFF_ACTION_TYPE,
    staffHistoryTabEnums,
    staffHistoryTabTypes,
    stffHistoryBody,
    stffHistoryHead,
} from './constants';

const ACTION_TYPE = 'GET_HISTORY';
export const StaffHistory = ({ }) => {
    const dispatch = useDispatch();
    const historyList = useSelector((state) => state.history.history);
    const staffHistory = useSelector((state) => state.history.staffHistory);
    const location = useLocation();
    const info = location?.state;
    const simpleHistory = !info?.tabType || info?.tabType === staffHistoryTabEnums?.ON_STAFF;
    const byStaffHistory = info?.tabType === staffHistoryTabEnums?.BY_STAFF;
    const localParams = useParams();

    useEffect(() => {
        const params = {
            ...info,
        };
        delete params.page;
        delete params.activeTab;
        delete params.from;
        delete params.tabType;
        params.skip = info?.skip ? info?.skip : 0;
        params.limit = 50;

        if (simpleHistory) {
            dispatch(historyActions.getHistory('Staff', { onResource: localParams?.id, ...params }));
        }

        if (byStaffHistory) {
            dispatch(historyActions.getStaffHistory(localParams?.id, params));
        }

    }, [info]);

    const renderSaveParams = () => {
        const saveParams = { ...info };
        delete saveParams.tabType;
        return saveParams;
    }

    return (
        <div>
            <div className="flex-align-center" style={{ gap: 16 }}>
                <TabSwitcher
                    list={staffHistoryTabTypes}
                    defaultType={staffHistoryTabEnums?.ON_STAFF}
                    save={renderSaveParams()}
                />
                <SearchHistory />
            </div>

            <FullTable
                head={simpleHistory ? historyHead : stffHistoryHead}
                body={simpleHistory ? historyBody : stffHistoryBody}
                loadingType={simpleHistory ? ACTION_TYPE : STAFF_ACTION_TYPE}
                list={simpleHistory ? historyList?.histories : staffHistory?.histories}
                listCount={simpleHistory ? historyList?.count : staffHistory?.count}
                notYet={historyNotYet}
                activeRowId={''}
            />
        </div>
    );
};
